import { openUserModal } from '../State/userModal'

export default (id) => (dispatch) => {

  dispatch(openUserModal({ id }))
  
}
